import axios from 'axios';
import config from '@/common/config';
import store from '@/store';
import { LOCAL_STORAGE_DEVICE_UUID } from '@/common/constants';

export default {
  async unauthorizedLog(locationTag, message) {
    const isConnected = navigator.onLine;
    let deviceUUID = localStorage.getItem(LOCAL_STORAGE_DEVICE_UUID);
    if (isConnected) {
      let prefix = axios.defaults.baseURL ? '' : '/api';
      try {
        await axios.post(prefix + `/logger/unauthorizedLog`, {
          deviceUUID,
          locationTag,
          message,
          userAgent: navigator.userAgent,
        });
      } catch (err) {
        console.log('failed to send log to remote. Ignoring', err);
      }
    }
  },
  async log(locationTag, message) {
    const isConnected = navigator.onLine;
    if (isConnected) {
      try {
        let deviceUUID = localStorage.getItem(LOCAL_STORAGE_DEVICE_UUID);
        let response = await axios.post(`/logger/log`, {
          deviceUUID,
          locationTag,
          message,
          userAgent: navigator.userAgent,
        });

        store.dispatch('setIsServerReachable', true);
      } catch (err) {
        console.warn('failed to send log to remote. Ignoring', err);
        store.dispatch('setIsServerReachable', false);
        store.dispatch('stopServerReachabilityCheck');
      }
    }
  },

  async getNow() {
    let response = await axios.get('/logger/getNow');

    if (response && response.data) {
      return { dbTime: response.data?.dbTime, apiTime: response.data?.apiTime };
    }
    return { dbTime: '', apiTime: '' };
  },

  async cockpitLog({ message, messageType, addBrowserInfo = false }) {
    let { screen, browser, browserVersion, mobile, os, osVersion } = config.browserInfo;
    let browserInfo = `${os} ${browser},${browserVersion},${mobile ? 'mobile' : 'desktop'}, screen:${screen}`;

    try {
      let deviceUUID = localStorage.getItem(LOCAL_STORAGE_DEVICE_UUID);
      let response = await axios.post('/logger/cockpitLog', {
        deviceUUID,
        screen,
        os,
        osVersion,
        browser,
        browserVersion,
        mobile,
        appVersion: config.appVersion,
        message: addBrowserInfo ? `${browserInfo}, ${message}` : message,
        messageType,
      });
      if (!deviceUUID || deviceUUID === 'undefined') {
        // the backend should create a deviceUUID if not existing so far (for example because device registration fails
        deviceUUID = response.data.deviceUUID;
        localStorage.setItem(LOCAL_STORAGE_DEVICE_UUID, deviceUUID);
      }
    } catch (err) {
      console.warn('cockpitLog failed to be sent due to bad or inexisting network connection', err);
    }
  },

  async deviceLog({ message, stackTrace, additionalInfo, messageType, addBrowserInfo = false }) {
    let { screen, browser, browserVersion, mobile, os, osVersion } = config.browserInfo;
    let browserInfo = `${os} ${browser},${browserVersion},${mobile ? 'mobile' : 'desktop'}, screen:${screen}`;

    try {
      let deviceUUID = localStorage.getItem(LOCAL_STORAGE_DEVICE_UUID);
      let response = await axios.post('/logger/deviceLog', {
        deviceUUID,
        screen,
        os,
        osVersion,
        browser,
        browserVersion,
        mobile,
        appVersion: config.appVersion,
        message: addBrowserInfo ? `${browserInfo}, ${message}` : message,
        stackTrace,
        additionalInfo,
        messageType,
      });
      if (!deviceUUID || deviceUUID === 'undefined') {
        // the backend should create a deviceUUID if not existing so far (for example because device registration fails
        deviceUUID = response.data.deviceUUID;
        localStorage.setItem(LOCAL_STORAGE_DEVICE_UUID, deviceUUID);
      }
    } catch (err) {
      console.warn('deviceLog failed to be sent due to bad or inexisting network connection', err);
    }
  },
};
